export default __webpack_public_path__ + "static/media/distributor_banner.40137141.png";